import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const blogsApi = createApi({
  reducerPath: "blogsApi",
  baseQuery: customFetchBase({ url: "blog" }),
  endpoints: (builder) => ({
    getAllBlogs: builder.query({
      query: ({ type = "blogs", code, search, page = 1 }) => {
        let queryParams = `type=${type}&page=${page}`;
        if (code) {
          queryParams += `&code=${code}`;
        }
        if (search) {
          queryParams += `&search=${search}`;
        }
        return {
          url: `?${queryParams}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetAllBlogsQuery } = blogsApi;
